export default {
  namespaced: true,
  state: {
    sales: [],
    sale: null,
    products: [],
  },
  actions: {
    GetSalesList({ commit, rootGetters }, payload) {
      commit('setField', { name: 'sales', value: [] });
      rootGetters.ax.post('sales/api/sale/list', payload)
        .then((response) => {
          commit('setField', { name: 'sales', value: response.data.sales });
        });
    },
    GetSale({ commit, state }, saleID) {
      commit('setField', { name: 'sale', value: null });
      if (state.sales.length) {
        if (saleID !== null) {
          const sale = state.sales.filter(item => item.id === saleID);
          sale.length && commit('setField', { name: 'sale', value: sale[0] });
        } else {
          commit('setField', { name: 'sale', value: null });
        }
      }
    },
    GetProductsList({ commit, rootGetters }) {
      commit('setField', { name: 'products', value: [] });
      rootGetters.ax.post('sales/api/product/list-products')
        .then((response) => {
          commit('setField', { name: 'products', value: response.data.products });
        });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
